import React from "react";
import { styled } from "@mui/material/styles";

export default styled("div")(({ theme }) => ({
  width: "0px",
  height: theme.spacing(2.5),
  borderLeft: `1px ${theme.custom.navigation.appBar.workspaceDivider.color} solid`,
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(1),
}));